import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {primaryTextColor, secondaryTextColor} from "~/theme";
import {UILineSkeleton} from "~/old-ui/UISkeleton";

export default function EntityHeadRow({label, loading, value, className, ...params}) {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, className)} {...params}>
      <div className={classes.label}>{label}</div>
      <div className={classes.value}>{loading ? (<UILineSkeleton width={228}/>) : value}</div>
    </div>
  )
}


const useStyles = createUseStyles({
  root: {
    display: 'flex',
    maxWidth: 575,
    alignItems: 'baseline',

    '& + &': {
      marginTop: 10,
    }
  },

  label: {
    color: secondaryTextColor,
    width: 92,
    minWidth: 92,
  },

  value: {
    color: primaryTextColor,
  }
});
